import React from "react";
import "./about.scss";

import doctor from "../../images/doctor.png";
import people from "../../images/people.png";
import live from "../../images/live.png";
import community from "../../images/community.png";
import makiyaj from "../../images/makiyaj.png";
import yoga from "../../images/yoga.png";

const About = () => {
  const items = [
    { img: doctor, text: "Ответ на ЛЮБОЙ вопрос от штатного врача" },
    { img: people, text: "Сопровождение с инструкцией на КАЖДЫЙ ДЕНЬ" },
    { img: live, text: "Прямые эфиры по основным проблемам здоровья с врачом-натуропатом" },
    { img: community, text: "Мотивацию и общение с участниками курса" },
    { img: makiyaj, text: "Практики по очищению кожи и кишечника" },
    { img: yoga, text: "Научитесь чувствовать свое тело с помощью тренировочных комплексов по растяжке и не только", small: true },
  ];

  return (
    <section  id="advantages" className="extra-benefits">
      <h2>Что Вы дополнительно получите</h2>

      <div className="benefits-grid">
        {items.map((item, index) => (
          <div
            key={index}
            className={`benefit-card ${item.small ? "small-text" : ""}`}
          >
            <div className="icon-wrapper">
              <span className="bg"></span>
              <img src={item.img} alt="" />
            </div>
            <p>{item.text}</p>
          </div>
        ))}
      </div>

      <div className="bottom">
        <div className="info">
          <span className="big">2 МЛН+</span>
          <p>
            Курс прошли более <b>2 000 000 человек</b>
          </p>
        </div>
       <a
  href="https://t.me/nasokahuz"
  target="_blank"
  rel="noopener noreferrer"
  className="price-btn"
>
  Смотреть в Telegram
</a>
      </div>
    </section>
  );
};

export default About;
